"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var editor_bind_field_popup_component_1 = require("./editor-bind-field-popup/editor-bind-field-popup.component");
var editor_bind_table_popup_component_1 = require("./editor-bind-table-popup/editor-bind-table-popup.component");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var uuid_1 = require("uuid");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var editor_expression_popup_component_1 = require("./editor-expression-popup/editor-expression-popup.component");
var editor_static_data_1 = require("./editor-static-data");
var i_expression_evaluation_service_1 = require("../../service/i-expression-evaluation.service");
var of_1 = require("rxjs/observable/of");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var moment = require("moment");
var editor_import_document_popup_component_1 = require("./editor-import-document-popup/editor-import-document-popup.component");
var EditorComponent = /** @class */ (function () {
    function EditorComponent(_dialog, _messageService, _elementRef, _currentLanguageProvider, expressionEvaluationService) {
        this._dialog = _dialog;
        this._messageService = _messageService;
        this._elementRef = _elementRef;
        this._currentLanguageProvider = _currentLanguageProvider;
        this.expressionEvaluationService = expressionEvaluationService;
        this.imageSizeA4 = [595.28, 841.89];
        this.margins = [35, 35, 20, 75];
        /**
         * Indicates if editor is in the form and entity is present or is in export builder
         */
        this.isEntityContextAvailable = false;
        /**
         * Indicates mode of editor, it can be simple text editor or export editor
         */
        this.isSimpleEditorMode = false;
        this.template = '';
        this.templateChange = new core_1.EventEmitter();
        this._destroy$ = new Subject_1.Subject();
        this.tooltipMessageKeys = [
            'ui_tb.editor.tools.bold_tooltip',
            'ui_tb.editor.tools.italic_tooltip',
            'ui_tb.editor.tools.underline_tooltip',
            'ui_tb.editor.tools.strikethrough_tooltip',
            'ui_tb.editor.tools.align_text_left_tooltip',
            'ui_tb.editor.tools.center_text_tooltip',
            'ui_tb.editor.tools.align_text_right_tooltip',
            'ui_tb.editor.tools.justify_tooltip',
            'ui_tb.editor.tools.insert_unordered_list_tooltip',
            'ui_tb.editor.tools.insert_ordered_list_tooltip',
            'ui_tb.editor.tools.indent_tooltip',
            'ui_tb.editor.tools.insert_hyperlink_tooltip',
            'ui_tb.editor.tools.create_table_tooltip',
            'ui_tb.editor.tools.view_html_tooltip',
            'ui_tb.editor.tools.format_tooltip',
            'ui_tb.editor.tools.clean_formatting_tooltip',
            'ui_tb.editor.tools.select_font_family_tooltip',
            'ui_tb.editor.tools.color_tooltip',
            'ui_tb.editor.tools.bg_color_tooltip',
            'ui_tb.editor.tools.select_font_size_tooltip',
            'ui_tb.editor.tools.add_dynamic_data_tooltip',
            'ui_tb.editor.tools.add_data_table_tooltip',
            'ui_tb.editor.add_expression.title',
            'ui_tb.editor.add_page_number.title',
            'ui_tb.editor.tools.add_image_table_tooltip',
            'ui_tb.editor.tools.table_wizard_tooltip',
            'ui_tb.editor.tools.add_row_above_tooltip',
            'ui_tb.editor.tools.add_row_below_tooltip',
            'ui_tb.editor.tools.add_column_left_tooltip',
            'ui_tb.editor.tools.add_column_right_tooltip',
            'ui_tb.editor.tools.delete_row_tooltip',
            'ui_tb.editor.tools.delete_column_tooltip',
            'ui_tb.editor.add_qr_code.title',
            'ui_tb.editor.dynamic_data_placeholder',
            'ui_tb.editor.total_page_number.title',
            'ui_tb.editor.import_document.import_button'
        ];
        this.fontSize = 'inherit';
        this.dynamicDataMessage = '';
        this._uniqueId = uuid_1.v4();
        this.containerId = "sis-template-editor-" + this._uniqueId;
        this._editorId = "sis-editor-" + this._uniqueId;
        // Calculate A4 document sizes with margins
        this.documentWidth = this.imageSizeA4[0] - (this.margins[0] + this.margins[2]);
        this.documentHeight = this.imageSizeA4[1] - (this.margins[1] + this.margins[3]);
    }
    EditorComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this._currentLanguageProvider.getCurrentLanguage()
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (language) { return _this.updateEditor(language); });
    };
    EditorComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    EditorComponent.prototype.updateEditor = function (language) {
        // remove existing kendo editor component
        if (this.findElement("#" + this._editorId).data('kendoEditor')) {
            this.findElement("#" + this.containerId).empty();
        }
        // re-initialize editor
        this.initEditor(this.template, language);
    };
    EditorComponent.prototype.initEditor = function (value, language) {
        var _this = this;
        //  load tooltip messages
        this._messageService.getMessages(language.getId(), this.tooltipMessageKeys)
            .then(function (messagesMap) {
            _this.messages = messagesMap;
            _this.dynamicDataMessage = _this.messages.get('ui_tb.editor.dynamic_data_placeholder');
            // create editor container
            var editorContainer = $('<textarea></textarea>');
            editorContainer.attr('id', _this._editorId);
            editorContainer.attr('rows', '10');
            editorContainer.attr('cols', '30');
            editorContainer.attr('style', 'height:400px');
            editorContainer.appendTo("#" + _this.containerId);
            // TODO: fix according bugs in future versions
            // enable shift on enter (without shift following element's styles are being copied)
            // const defaultTools = kendo.ui.Editor.defaultTools;
            // defaultTools['insertParagraph'].options.shift = true;
            _this.findElement("#" + _this._editorId).kendoEditor({
                keyup: function (e) {
                    // Bind events after Ctrl+Z and Ctrl+Y
                    if ((e.keyCode === 89 || e.keyCode === 90) && e.ctrlKey && !_this.isEntityContextAvailable) {
                        _this.bindElementClickEvents();
                    }
                    if (e.keyCode === 46 || e.keyCode === 8) {
                        _this.deleteEmptyDivs();
                    }
                },
                value: value,
                change: function (event) { return _this.templateChange.emit(event.sender.element.data('kendoEditor').value()); },
                tools: _this.isEntityContextAvailable || _this.isSimpleEditorMode ?
                    _this.getStandardTools() : _this.getStandardTools().concat(_this.getCustomTools())
            });
            // append editor stylesheet
            var head = _this.findElement('iframe').contents().find('head');
            var css = "<style type=\"text/css\">" + editor_static_data_1.editorStyles + "</style>";
            $(head).append(css);
            _this.findElement('iframe').height('600px');
            var editor = _this.findElement("#" + _this._editorId).data('kendoEditor');
            editor.bind('select', function () {
                _this.fontSize = editor.state('fontSize');
            });
            _this.bindCustomImageInsertToolEvent();
            if (!_this.isSimpleEditorMode) {
                _this.dynamicFieldElements = _this.findContextElement('.label');
                _this.dynamicExpressionElements = _this.findContextElement('.expression');
                _this.dynamicTableElements = _this.findContextElement('.table');
                _this.fixTableStyles();
                if (!_this.isEntityContextAvailable) {
                    _this.replaceContentWithPlaceholder();
                    _this.bindCustomToolEvents();
                    _this.bindElementClickEvents();
                    _this.changeCursorType('pointer');
                }
                else {
                    idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(_this.expressionEvaluationService);
                    var expressions = _this.collectDynamicBindings();
                    _this.getEvaluatedExpressions(expressions)
                        .pipe(operators_1.takeUntil(_this._destroy$))
                        .subscribe(function (evaluatedExpressions) {
                        evaluatedExpressions.size > 0 && _this.replaceWithEvaluatedExpressions(evaluatedExpressions);
                    });
                    _this.previewTable();
                    _this.changeCursorType();
                }
                _this.addTitleToExistingBindings();
            }
        });
    };
    EditorComponent.prototype.bindCustomToolEvents = function () {
        var _this = this;
        this.findElement('#bind-label-icon').click(function () { return _this.openBindFieldPopup(); });
        this.findElement('#bind-table-icon').click(function () { return _this.openBindTablePopup(); });
        this.findElement('#expression-icon').click(function () { return _this.openExpressionPopup(); });
        this.findElement('#total-page-number-tool-icon').click(function () { return _this.createTotalPageNumberElement(); });
        this.findElement('#qr-code-tool-icon').click(function () { return _this.createQRCodeElement(); });
        this.findElement('#import-tool-icon').click(function () { return _this.openImportDocumentPopup(); });
    };
    EditorComponent.prototype.bindCustomImageInsertToolEvent = function () {
        var _this = this;
        this.findElement('#insert-image-icon').click(function () { return _this.openUploadImagePopup(); });
    };
    EditorComponent.prototype.bindElementClickEvents = function () {
        var _this = this;
        this.dynamicFieldElements.unbind();
        this.dynamicTableElements.unbind();
        this.dynamicExpressionElements.unbind();
        this.dynamicFieldElements.click(function (event) { return _this.openBindFieldPopup($(event.delegateTarget)); });
        this.dynamicTableElements.click(function (event) { return _this.openBindTablePopup($(event.delegateTarget)); });
        this.dynamicExpressionElements.click(function (event) { return _this.openExpressionPopup($(event.delegateTarget)); });
    };
    EditorComponent.prototype.changeCursorType = function (type) {
        if (type === void 0) { type = 'default'; }
        this.dynamicFieldElements.css('cursor', "" + type);
        this.dynamicExpressionElements.css('cursor', "" + type);
    };
    /**
     * Adds title attribute to existing bindings for backward compatibility
     * @private
     */
    EditorComponent.prototype.addTitleToExistingBindings = function () {
        for (var i = 0; i < this.dynamicFieldElements.length; i++) {
            var element = this.dynamicFieldElements.eq(i);
            element.attr('title', element.attr('binding'));
        }
        for (var i = 0; i < this.dynamicExpressionElements.length; i++) {
            var element = this.dynamicExpressionElements.eq(i);
            element.attr('title', element.attr('binding'));
        }
    };
    /**
     * Replaces bindings content with static message for backward compatibility
     * @private
     */
    EditorComponent.prototype.replaceContentWithPlaceholder = function () {
        var _this = this;
        this.dynamicFieldElements.each(function (index, element) {
            _this.replaceTextContentOfDynamicFields(index, element, "[" + _this.dynamicDataMessage + "]");
        });
        this.dynamicExpressionElements.each(function (index, element) {
            _this.replaceTextContentOfDynamicFields(index, element, "[" + _this.dynamicDataMessage + "]");
        });
    };
    EditorComponent.prototype.replaceTextContentOfDynamicFields = function (index, element, text) {
        var textElement = this.findLastChild(element);
        textElement.text(text);
    };
    EditorComponent.prototype.findLastChild = function (element) {
        if (!$(element).children().length) {
            return $(element);
        }
        else {
            return this.findLastChild($(element).children().first());
        }
    };
    EditorComponent.prototype.openBindFieldPopup = function (field) {
        var _this = this;
        var data = {
            width: '650px',
            height: '500px',
            disableClose: true,
            data: {
                categoryName: this.metaCategoryId.getSystemName(),
                emptyState: field ? field.attr('emptystate') : '',
                selectedMetaFieldBinding: field ? field.attr('binding') : '',
                condition: field ? field.attr('condition') : '',
                format: field ? field.attr('format') : '',
                type: field ? field.attr('type') : ''
            }
        };
        var dialogRef = this._dialog.open(editor_bind_field_popup_component_1.EditorBindFieldPopupComponent, data);
        dialogRef.beforeClose().pipe(operators_1.takeUntil(this._destroy$)).subscribe(function (model) {
            if (model) {
                var element_1 = _this.insertOrUpdateElement(_this.createBindFieldElement(model), field);
                element_1.click(function () { return _this.openBindFieldPopup(element_1); });
            }
        });
    };
    EditorComponent.prototype.openExpressionPopup = function (field) {
        var _this = this;
        var data = {
            width: '500px',
            height: '500px',
            disableClose: true,
            data: {
                expression: field ? field.attr('binding') : '',
                condition: field ? field.attr('condition') : '',
                emptyState: field ? field.attr('emptystate') : '',
            }
        };
        var dialogRef = this._dialog.open(editor_expression_popup_component_1.EditorExpressionPopupComponent, data);
        dialogRef.beforeClose().pipe(operators_1.takeUntil(this._destroy$)).subscribe(function (model) {
            if (model) {
                var element_2 = _this.insertOrUpdateElement(_this.createExpressionElement(model), field);
                element_2.click(function () { return _this.openExpressionPopup(element_2); });
            }
        });
    };
    EditorComponent.prototype.openImportDocumentPopup = function () {
        var _this = this;
        var data = {
            width: '640px',
            height: 'auto',
            disableClose: true
        };
        var dialogRef = this._dialog.open(editor_import_document_popup_component_1.EditorImportDocumentPopupComponent, data);
        dialogRef.beforeClose().pipe(operators_1.takeUntil(this._destroy$)).subscribe(function (result) {
            if (result && result.length) {
                var resultJquery = $(result);
                _this.findElement("#" + _this._editorId).data('kendoEditor').exec('inserthtml', {
                    value: $(resultJquery[resultJquery.length - 1]).prop('innerHTML')
                });
            }
        });
    };
    EditorComponent.prototype.openBindTablePopup = function (table) {
        var _this = this;
        var data = {
            width: '500px',
            height: '500px',
            disableClose: true,
            data: {
                categoryName: this.metaCategoryId.getSystemName(),
                metaFieldSystemName: table ? table.attr('category').split('.')[1] : '',
                selectedColumns: table ? table.attr('selectedcolumns').split(',') : '',
                isNumbering: table ? table.attr('isNumbering') : '',
                isShowEmptyRow: table ? table.attr('isShowEmptyRow') : '',
                condition: table ? table.attr('condition') : '',
            }
        };
        var dialogRef = this._dialog.open(editor_bind_table_popup_component_1.EditorBindTablePopupComponent, data);
        dialogRef.beforeClose().pipe(operators_1.takeUntil(this._destroy$)).subscribe(function (model) {
            if (model) {
                var element_3 = _this.insertOrUpdateElement(_this.createBindTableElement(model), table);
                element_3.click(function () { return _this.openBindTablePopup(element_3); });
            }
        });
    };
    EditorComponent.prototype.openUploadImagePopup = function () {
        var _this = this;
        var imageContainer = $('#selectImage');
        imageContainer.trigger('click');
        imageContainer.one('change', function (event) {
            var image = event.target.files[0];
            _this.convertFileToBase64AndInsert(image);
        });
    };
    EditorComponent.prototype.convertFileToBase64AndInsert = function (image) {
        return __awaiter(this, void 0, void 0, function () {
            var convertedImage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                            var reader = new FileReader();
                            reader.readAsDataURL(image);
                            reader.onload = function () {
                                var imageFile = new Image();
                                imageFile.src = reader.result;
                                imageFile.onload = function () {
                                    resolve({
                                        image: reader.result,
                                        width: imageFile.width,
                                        height: imageFile.height
                                    });
                                };
                            };
                            reader.onerror = function (error) { return reject(error); };
                        })];
                    case 1:
                        convertedImage = _a.sent();
                        this.insertOrUpdateElement(this.createImageElement(convertedImage, image.imageName), null);
                        return [2 /*return*/];
                }
            });
        });
    };
    EditorComponent.prototype.insertOrUpdateElement = function (newElement, prevElement) {
        var newContent = newElement.prop('outerHTML');
        if (prevElement) {
            // replace the existing element in editor context.
            this.findContextElement("#" + prevElement.attr('id')).replaceWith(newContent);
        }
        else {
            // insert the new html element in the editor context.
            this.findElement("#" + this._editorId).data('kendoEditor').exec('inserthtml', {
                value: newContent
            });
        }
        // return the final html element for this binding.
        return this.findContextElement("#" + newElement.attr('id'));
    };
    EditorComponent.prototype.createBindFieldElement = function (data) {
        var selector = "bound-element-" + new Date().getTime();
        var boundSpanElement = $('<span></span>');
        if (data.isDateField) {
            boundSpanElement.attr('format', data.format);
        }
        boundSpanElement.attr('id', selector);
        boundSpanElement.attr('class', 'label');
        boundSpanElement.attr('binding', data.selectedMetaFieldBinding);
        boundSpanElement.attr('emptystate', data.emptyState);
        boundSpanElement.attr('contenteditable', 'false');
        boundSpanElement.attr('title', data.selectedMetaFieldBinding);
        if (this.fontSize !== 'inherit') {
            boundSpanElement.attr('style', "font-size: " + this.fontSize);
        }
        if (data.condition) {
            boundSpanElement.attr('condition', data.condition);
        }
        if (data.type) {
            boundSpanElement.attr('type', data.type);
        }
        boundSpanElement.text("[" + this.dynamicDataMessage + "]");
        return boundSpanElement;
    };
    EditorComponent.prototype.createExpressionElement = function (data) {
        var selector = "bound-expression-" + new Date().getTime();
        var boundSpanElement = $('<span></span>');
        boundSpanElement.attr('id', selector);
        boundSpanElement.attr('class', 'expression');
        boundSpanElement.attr('binding', data.expression);
        boundSpanElement.attr('emptystate', data.emptyState);
        boundSpanElement.attr('contenteditable', 'false');
        boundSpanElement.attr('title', data.expression);
        if (this.fontSize !== 'inherit') {
            boundSpanElement.attr('style', "font-size: " + this.fontSize);
        }
        if (data.condition) {
            boundSpanElement.attr('condition', data.condition);
        }
        boundSpanElement.text("[" + this.dynamicDataMessage + "]");
        return boundSpanElement;
    };
    EditorComponent.prototype.createTotalPageNumberElement = function () {
        var selector = "bound-totalPageNumber-" + new Date().getTime();
        var boundSpanElement = $('<span></span>');
        boundSpanElement.attr('id', selector);
        boundSpanElement.attr('class', 'totalPageNumber');
        boundSpanElement.attr('contenteditable', 'false');
        boundSpanElement.attr('title', this.messages.get('ui_tb.editor.total_page_number.title'));
        if (this.fontSize !== 'inherit') {
            boundSpanElement.attr('style', "font-size: " + this.fontSize);
        }
        boundSpanElement.text("[" + this.dynamicDataMessage + "]");
        this.insertOrUpdateElement(boundSpanElement, undefined);
    };
    EditorComponent.prototype.createQRCodeElement = function () {
        var selector = "qr-code-image-element-" + new Date().getTime();
        var image = $('<img />', {
            id: selector,
            src: editor_static_data_1.qrCodeSrc,
            alt: 'QR code',
            class: 'qrcode',
            binding: 'data.QR_data'
        });
        var element = $('<p>').append(image);
        this.insertOrUpdateElement(element, null);
    };
    EditorComponent.prototype.createImageElement = function (convertedImage, imageName) {
        var selector = "image-element-" + new Date().getTime();
        var _a = this.fitImageToA4(convertedImage.width, convertedImage.height), width = _a[0], height = _a[1];
        var image = $('<img />', {
            id: selector,
            src: convertedImage.image,
            alt: imageName,
            class: 'image',
            width: width,
            height: height
        });
        return $('<p>').append(image);
    };
    EditorComponent.prototype.fitImageToA4 = function (width, height) {
        if (width > this.documentWidth || height > this.documentHeight) {
            var ratio = width / height > this.documentWidth / this.documentHeight ? this.documentWidth / width : this.documentHeight / height;
            return [width * ratio, height * ratio];
        }
        return [width, height];
    };
    EditorComponent.prototype.createBindTableElement = function (data) {
        var metaFieldSystemName = data.selectedFunctionalField;
        var tableElement = $('<div></div>');
        tableElement.attr('class', 'table');
        tableElement.attr('category', this.metaCategoryId.getSystemName() + "." + metaFieldSystemName);
        tableElement.attr('id', "bound-table-" + new Date().getTime());
        tableElement.attr('selectedcolumns', data.selectedColumns.map(function (column) { return column.value.id; }).toString());
        tableElement.attr('isNumbering', "" + data.isNumbering);
        tableElement.attr('isShowEmptyRow', "" + data.isShowEmptyRow);
        if (data.condition) {
            tableElement.attr('condition', data.condition);
        }
        var headerElement = this.getHeaderElement(data);
        var bodyElement = this.getBodyElement(data);
        if (!data.isShowEmptyRow) {
            bodyElement.css('display', 'none');
        }
        else {
            bodyElement.attr('style', 'display: flex; flex-wrap: nowrap');
        }
        tableElement.append(headerElement);
        tableElement.append(bodyElement);
        return tableElement;
    };
    EditorComponent.prototype.getHeaderElement = function (data) {
        var _this = this;
        var commonStyles = 'padding-left:4px;padding-bottom:14px;';
        var border = '1px solid #808080';
        var headerElement = $('<header></header>');
        headerElement.attr('class', 'header');
        headerElement.attr('style', 'display: flex; flex-wrap: nowrap;');
        if (data.isNumbering) {
            var headerSpanElement = $('<span></span>');
            headerSpanElement.text('№');
            headerSpanElement.attr('style', commonStyles + "border:" + border + ";width:50px;");
            headerElement.append(headerSpanElement);
        }
        data.selectedColumns.forEach(function (column, index) {
            var headerSpanElement = $('<span></span>');
            headerSpanElement.text((column.displayName && _this.language) ?
                column.displayName.getValue(_this.language.getId()) : column.name);
            if (index === 0 && !data.isNumbering) {
                headerSpanElement.attr('style', commonStyles + "border:" + border + ";width:210px;");
            }
            else {
                headerSpanElement.attr('style', commonStyles + "border-top:" + border + ";border-right:" + border + ";border-bottom:" + border + ";width:210px;");
            }
            headerElement.append(headerSpanElement);
        });
        return headerElement;
    };
    EditorComponent.prototype.getBodyElement = function (data) {
        var commonStyles = 'padding-left:4px;padding-bottom:14px;';
        var border = '1px solid #808080';
        var bodyElement = $('<section></section>');
        bodyElement.attr('class', 'body');
        if (data.isNumbering) {
            var bodySpanElement = $('<span></span>');
            bodySpanElement.attr('style', commonStyles + "border-left:" + border + ";border-bottom:" + border + ";border-right:" + border + ";width:50px;");
            bodySpanElement.attr('index', 'true');
            bodySpanElement.text('');
            bodyElement.append(bodySpanElement);
        }
        data.selectedColumns.forEach(function (column, index) {
            var bodySpanElement = $('<span></span>');
            bodySpanElement.innerText = '';
            bodySpanElement.attr('binding', column.value.bindingName);
            if (index === 0 && !data.isNumbering) {
                bodySpanElement.attr('style', commonStyles + "border-left:" + border + ";border-bottom:" + border + ";border-right:" + border + ";width:210px;");
            }
            else {
                bodySpanElement.attr('style', commonStyles + "border-bottom:" + border + ";border-right:" + border + ";width:210px;");
            }
            bodyElement.append(bodySpanElement);
        });
        return bodyElement;
    };
    EditorComponent.prototype.deleteEmptyDivs = function () {
        var divs = this.findContextElement('.resizable');
        divs.map(function (index, div) {
            if (!div.getElementsByTagName('img').length) {
                div.remove();
            }
        });
    };
    EditorComponent.prototype.findElement = function (selector) {
        return $(this._elementRef.nativeElement).find(selector);
    };
    EditorComponent.prototype.findContextElement = function (selector) {
        return this.findElement('iframe').contents().find(selector);
    };
    EditorComponent.prototype.getStandardTools = function () {
        return [
            { name: 'bold', tooltip: this.messages.get('ui_tb.editor.tools.bold_tooltip') },
            { name: 'italic', tooltip: this.messages.get('ui_tb.editor.tools.italic_tooltip') },
            { name: 'underline', tooltip: this.messages.get('ui_tb.editor.tools.underline_tooltip') },
            { name: 'strikethrough', tooltip: this.messages.get('ui_tb.editor.tools.strikethrough_tooltip') },
            { name: 'justifyLeft', tooltip: this.messages.get('ui_tb.editor.tools.align_text_left_tooltip') },
            { name: 'justifyCenter', tooltip: this.messages.get('ui_tb.editor.tools.center_text_tooltip') },
            { name: 'justifyRight', tooltip: this.messages.get('ui_tb.editor.tools.align_text_right_tooltip') },
            { name: 'justifyFull', tooltip: this.messages.get('ui_tb.editor.tools.justify_tooltip') },
            {
                name: 'insertUnorderedList',
                tooltip: this.messages.get('ui_tb.editor.tools.insert_unordered_list_tooltip')
            },
            { name: 'insertOrderedList', tooltip: this.messages.get('ui_tb.editor.tools.insert_ordered_list_tooltip') },
            { name: 'indent', tooltip: this.messages.get('ui_tb.editor.tools.indent_tooltip') },
            { name: 'outdent', tooltip: this.messages.get('ui_tb.editor.tools.outdent_tooltip') },
            { name: 'createLink', tooltip: this.messages.get('ui_tb.editor.tools.insert_hyperlink_tooltip') },
            { name: 'unlink', tooltip: this.messages.get('ui_tb.editor.tools.unlink_tooltip') },
            { name: 'tableWizard', tooltip: this.messages.get('ui_tb.editor.tools.table_wizard_tooltip') },
            { name: 'createTable', tooltip: this.messages.get('ui_tb.editor.tools.create_table_tooltip') },
            { name: 'addRowAbove', tooltip: this.messages.get('ui_tb.editor.tools.add_row_above_tooltip') },
            { name: 'addRowBelow', tooltip: this.messages.get('ui_tb.editor.tools.add_row_below_tooltip') },
            { name: 'addColumnLeft', tooltip: this.messages.get('ui_tb.editor.tools.add_column_left_tooltip') },
            { name: 'addColumnRight', tooltip: this.messages.get('ui_tb.editor.tools.add_column_right_tooltip') },
            { name: 'deleteRow', tooltip: this.messages.get('ui_tb.editor.tools.delete_row_tooltip') },
            { name: 'deleteColumn', tooltip: this.messages.get('ui_tb.editor.tools.delete_column_tooltip') },
            { name: 'viewHtml', tooltip: this.messages.get('ui_tb.editor.tools.view_html_tooltip') },
            { name: 'formatting', tooltip: this.messages.get('ui_tb.editor.tools.format_tooltip') },
            { name: 'cleanFormatting', tooltip: this.messages.get('ui_tb.editor.tools.clean_formatting_tooltip') },
            {
                name: 'fontName',
                items: [
                    { text: 'Arial', value: 'Arial' },
                    { text: 'Ariblk', value: 'Ariblk' },
                    { text: 'Bangla', value: 'Bangla' },
                    { text: 'Ecsquaresanspro', value: 'Ecsquaresanspro' },
                    { text: 'Kalpurush', value: 'Kalpurush' },
                    { text: 'Lucon', value: 'Lucon' },
                    { text: 'Nikosh', value: 'Nikosh' },
                    { text: 'Times', value: 'Times' },
                    { text: 'Verdana', value: 'Verdana' }
                ], tooltip: this.messages.get('ui_tb.editor.tools.select_font_family_tooltip')
            },
            { name: 'foreColor', tooltip: this.messages.get('ui_tb.editor.tools.color_tooltip') },
            { name: 'backColor', tooltip: this.messages.get('ui_tb.editor.tools.bg_color_tooltip') },
            {
                name: 'fontSize',
                items: [
                    { text: '11px', value: '11px' },
                    { text: '12px', value: '12px' },
                    { text: '13px', value: '13px' },
                    { text: '14px', value: '14px' },
                    { text: '15px', value: '15px' },
                    { text: '16px', value: '16px' },
                    { text: '18px', value: '18px' },
                    { text: '20px', value: '20px' }
                ], tooltip: this.messages.get('ui_tb.editor.tools.select_font_size_tooltip')
            },
            {
                name: 'customToolInsertImage',
                template: "<input style=\"display:none\" type=\"file\" id=\"selectImage\" accept=\".png, .jpg, .jpeg, .gif, .svg, .bmp, .exif, .jfif, .jif, .tiff, .tif\"><a role=\"button\" type=\"text/x-kendo-template\" class=\"k-tool\"><img src=\"icons/image_ic.svg\" id=\"insert-image-icon\" title=\"" + this.messages.get('ui_tb.editor.tools.add_image_table_tooltip') + "\" alt=\"Bind field icon\"/></a>"
            },
        ];
    };
    EditorComponent.prototype.getCustomTools = function () {
        return [
            {
                name: 'customToolFieldBinding',
                template: "<a role=\"button\" type=\"text/x-kendo-template\" id=\"label-binding\" class=\"k-tool\"><img id=\"bind-label-icon\" src=\"icons/label_ic.svg\" title=\"" + this.messages.get('ui_tb.editor.tools.add_dynamic_data_tooltip') + "\" alt=\"Bind field icon\"/></a>"
            },
            {
                name: 'customToolTableBinding',
                template: "<a role=\"button\" type=\"text/x-kendo-template\" id=\"table-binding\" class=\"k-tool\"><img id=\"bind-table-icon\" src=\"icons/table_ic.svg\" title=\"" + this.messages.get('ui_tb.editor.tools.add_data_table_tooltip') + "\" alt=\"Bind table icon\"/></a>"
            },
            {
                name: 'customToolExpression',
                template: "<a role=\"button\" type=\"text/x-kendo-template\" id=\"expression-tool\" class=\"k-tool\"><img id=\"expression-icon\" src=\"icons/expression.svg\" title=\"" + this.messages.get('ui_tb.editor.add_expression.title') + "\" alt=\"Bind table icon\"/></a>"
            },
            {
                name: 'customToolTotalPageNumber',
                template: "<a role=\"button\" type=\"text/x-kendo-template\" id=\"total-page-number-tool\" class=\"k-tool\"><img id=\"total-page-number-tool-icon\" src=\"icons/totalPageNumber.svg\" title=\"" + this.messages.get('ui_tb.editor.add_page_number.title') + "\" alt=\"Page Number icon\"/></a>"
            },
            {
                name: 'qrCodeTool',
                template: "<a role=\"button\" type=\"text/x-kendo-template\" id=\"qr-code-tool\" class=\"k-tool\"><img id=\"qr-code-tool-icon\" src=\"icons/qr_ic.svg\" title=\"" + this.messages.get('ui_tb.editor.add_qr_code.title') + "\" alt=\"QR code\"/> </a>"
            },
            {
                name: 'importTool',
                template: "<a role=\"button\" type=\"text/x-kendo-template\" id=\"import-tool\" class=\"k-tool\"><img id=\"import-tool-icon\" src=\"icons/import-tool.svg\" title=\"" + this.messages.get('ui_tb.editor.import_document.import_button') + "\" alt=\"Import\"/></a>"
            }
        ];
    };
    /**
     * Collects all dynamic bindings, conditions, expressions.
     * @return string[] - list of bindings
     * @private
     */
    EditorComponent.prototype.collectDynamicBindings = function () {
        var expressions = [];
        this.dynamicFieldElements.each(function (index, value) {
            var binding = $(value).attr('binding');
            var condition = $(value).attr('condition');
            binding && binding.length > 0 && expressions.push('${' + binding + '}');
            condition && condition.length > 0 && expressions.push('${' + condition + '}');
        });
        this.dynamicExpressionElements.each(function (index, value) {
            var binding = $(value).attr('binding');
            var condition = $(value).attr('condition');
            binding && binding.length > 0 && expressions.push('${' + binding + '}');
            condition && condition.length > 0 && expressions.push('${' + condition + '}');
        });
        return expressions;
    };
    EditorComponent.prototype.getEvaluatedExpressions = function (expressions) {
        return expressions.length > 0 ?
            this.expressionEvaluationService.getEvaluatedExpressionsValues(expressions)
            : of_1.of(new Map());
    };
    /**
     * Replaces dynamic bindings with evaluated values
     * @param evaluatedExpressions
     * @private
     */
    EditorComponent.prototype.replaceWithEvaluatedExpressions = function (evaluatedExpressions) {
        var _this = this;
        this.dynamicFieldElements.each(function (index, element) {
            _this.replaceTextContentOfDynamicFields(index, element, _this.calculateExpressionDisplayValue(element, evaluatedExpressions));
        });
        this.dynamicExpressionElements.each(function (index, element) {
            _this.replaceTextContentOfDynamicFields(index, element, _this.calculateExpressionDisplayValue(element, evaluatedExpressions));
        });
    };
    /**
     * Calculates dynamic bindings conditions, format and empty state and returns final value
     * @param element
     * @param evaluatedExpressions
     * @return string - final value
     * @private
     */
    EditorComponent.prototype.calculateExpressionDisplayValue = function (element, evaluatedExpressions) {
        element = $(element);
        var binding = element.attr('binding');
        var condition = element.attr('condition');
        var emptyState = element.attr('emptyState') || '';
        var format = element.attr('format');
        var evaluatedBinding = binding ? evaluatedExpressions.get(binding) : '';
        format !== undefined && evaluatedBinding && (evaluatedBinding = moment(new Date(evaluatedBinding))['formatWithJDF'](format));
        var evaluatedCondition = condition ? evaluatedExpressions.get(condition) : true;
        return evaluatedCondition ? evaluatedBinding || emptyState : '';
    };
    // TODO: should be removed in future
    EditorComponent.prototype.previewTable = function () {
        this.findContextElement('.body').attr('style', 'display: flex; flex-wrap: nowrap; height: 30px');
    };
    // TODO: should be removed in future
    EditorComponent.prototype.fixTableStyles = function () {
        this.dynamicTableElements.each(function (index, value) {
            $(value).css('cursor', 'default');
            if (value) {
                var commonStyles_1 = {
                    'display': '',
                    'padding': '',
                    'padding-left': '4px',
                    'padding-bottom': '14px',
                };
                var border_1 = '1px solid #808080';
                var headerElement = $(value.children[0]);
                var bodyElement = $(value.children[1]);
                headerElement.attr('style', 'display: flex; flex-wrap: nowrap;');
                var headerColumns = headerElement.find('span');
                headerColumns.each(function (columnIndex, columnValue) {
                    $(columnValue).css(commonStyles_1);
                    $(columnValue).css({
                        'border-top': '',
                        'border-right': '',
                        'border-bottom': '',
                        'border-left': ''
                    });
                    if (columnIndex === 0) {
                        $(columnValue).css({ 'border': "" + border_1 });
                    }
                    else {
                        $(columnValue).css({
                            'border-top': "" + border_1,
                            'border-right': "" + border_1,
                            'border-bottom': "" + border_1
                        });
                    }
                });
                var bodyColumns = bodyElement.find('span');
                bodyColumns.each(function (columnIndex, columnValue) {
                    $(columnValue).css(commonStyles_1);
                    $(columnValue).css({
                        'border-top': '',
                        'border-right': '',
                        'border-bottom': '',
                        'border-left': ''
                    });
                    if (columnIndex === 0) {
                        $(columnValue).css({
                            'border-left': "" + border_1,
                            'border-right': "" + border_1,
                            'border-bottom': "" + border_1
                        });
                    }
                    else {
                        $(columnValue).css({
                            'border-right': "" + border_1,
                            'border-bottom': "" + border_1
                        });
                    }
                });
            }
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], EditorComponent.prototype, "isEntityContextAvailable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], EditorComponent.prototype, "isSimpleEditorMode", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_kb_service_client_js_1.MetaCategoryId)
    ], EditorComponent.prototype, "metaCategoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], EditorComponent.prototype, "template", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_crosscutting_concepts_frontend_1.Language)
    ], EditorComponent.prototype, "language", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], EditorComponent.prototype, "templateChange", void 0);
    EditorComponent = __decorate([
        core_1.Component({
            selector: 'sis-template-editor',
            template: require('./editor.component.html'),
            styles: [require('./editor.component.css')]
        }),
        __param(4, core_1.Optional()),
        __metadata("design:paramtypes", [material_1.MatDialog,
            idm_message_language_service_client_js_1.MessageService,
            core_1.ElementRef,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            i_expression_evaluation_service_1.IExpressionEvaluationService])
    ], EditorComponent);
    return EditorComponent;
}());
exports.EditorComponent = EditorComponent;
//# sourceMappingURL=editor.component.js.map